import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["Component"];
import { SkeletonBrick, SkeletonCircle, Text } from '@carnica/ui-kit';
import classNames from 'classnames/bind';
import React from 'react';
import styles from "./styles.pcss";
var cn = classNames.bind(styles);
export var Option = function Option(_ref) {
  var text = _ref.text,
    iconUrl = _ref.iconUrl,
    onClick = _ref.onClick,
    _ref$rightComponentPr = _ref.rightComponentProps,
    _ref$rightComponentPr2 = _ref$rightComponentPr === void 0 ? {} : _ref$rightComponentPr,
    _ref$rightComponentPr3 = _ref$rightComponentPr2.Component,
    RightComponent = _ref$rightComponentPr3 === void 0 ? React.Fragment : _ref$rightComponentPr3,
    rightComponentProps = _objectWithoutProperties(_ref$rightComponentPr2, _excluded),
    className = _ref.className,
    iconClassName = _ref.iconClassName,
    isLoading = _ref.isLoading,
    Icon = _ref.Icon;
  if (isLoading) {
    return /*#__PURE__*/React.createElement("div", {
      className: cn('wrapper--skeleton'),
      "data-t-id": "PaymentMethodSection-Option"
    }, /*#__PURE__*/React.createElement("div", {
      className: cn('left')
    }, /*#__PURE__*/React.createElement(SkeletonCircle, {
      diameter: 44
    })), /*#__PURE__*/React.createElement("div", {
      className: cn('right')
    }, /*#__PURE__*/React.createElement(SkeletonBrick, {
      height: 20
    }), /*#__PURE__*/React.createElement(SkeletonBrick, {
      height: 12,
      width: 160
    })));
  }
  return /*#__PURE__*/React.createElement("button", {
    className: cn('wrapper', className),
    onClick: onClick,
    tabIndex: 0,
    type: "button"
  }, /*#__PURE__*/React.createElement("span", {
    className: cn('icon', iconClassName),
    style: {
      backgroundImage: "url(".concat(iconUrl, ")")
    }
  }, Icon && /*#__PURE__*/React.createElement(Icon, null)), /*#__PURE__*/React.createElement("div", {
    className: cn('content')
  }, /*#__PURE__*/React.createElement(Text, {
    color: "primary",
    variant: "body-small"
  }, text.title), text.subtitle && /*#__PURE__*/React.createElement(Text, {
    color: "secondary",
    variant: "body-small"
  }, text.subtitle)), /*#__PURE__*/React.createElement("span", {
    className: cn('rightIcon')
  }, /*#__PURE__*/React.createElement(RightComponent, rightComponentProps)));
};